document.addEventListener('DOMContentLoaded', () => {
  function getUTMParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || ''
    };
  }

  async function saveUTMsToCart(utmParams) {
    if (!utmParams.utm_source) return;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            _utm_source: utmParams.utm_source,
            _utm_medium: utmParams.utm_medium,
            _utm_campaign: utmParams.utm_campaign,
            _utm_content: utmParams.utm_content
          }
        })
      });
    } catch (error) {
      console.error('Failed to save UTM parameters:', error);
    }
  }

  document.addEventListener('click', (e) => {
    const addToCartBtn = e.target.closest('[name="add"]');
    if (addToCartBtn) {
      const utmParams = getUTMParams();
      saveUTMsToCart(utmParams);
    }
  });

  const utmParams = getUTMParams();
  if (utmParams.utm_source) {
    saveUTMsToCart(utmParams);
  }
});